import { fontSize, fontWeight, textAlign } from "@mui/system";
import { border } from "../../theme";
import { Box, Typography } from "@mui/material";

const ChooseFile = () => {
  return (
    <Box
      component={"Button"}
      sx={{
        background: "#E9ECEF",
        borderRadius: "8px 0px 0px 8px",
        width: "150px",
        height: "37px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        border: "none",
      }}
    >
      <Typography variant="body4">Choose File</Typography>
    </Box>
  );
};

export default ChooseFile;
